//@ts-nocheck
import React from 'react'
import { Query } from 'react-apollo'
import { get } from 'lodash'
import gql from 'graphql-tag'
import PageLoadingInterstitial from 'components/shared/interstitials/PageLoadingInterstitial'
import useFirebaseSession from 'hooks/useFirebaseSession'

const newsletterPageQuery = gql`

    query newsletterPageQuery($firebaseId: ID!) {

        user(firebaseId: $firebaseId) {
            id
            email
            isNewsletterSubscriber
        }
    }
`

function NewsletterPageQuery({ children }) {

    const parseData = data => ({
        user: get(data, 'user', {})
    })

    const { loggedInUserId } = useFirebaseSession()

    return (
        <Query query={newsletterPageQuery} variables={{ firebaseId: loggedInUserId }}>
            {({ loading, data, error }) => (
                loading || error
                ? <PageLoadingInterstitial loading={loading} error={error}/>
                : children(parseData(data))
            )}
        </Query>
    )
}

export default NewsletterPageQuery